
import { Injectable } from '@angular/core';
// import { DatatransferService } from '../dashboard2/datatransfer.service'
import { HttpClient, HttpHeaders } from '@angular/common/http';


@Injectable()
export class GasdetailsService {
  myMainTest : any;

  constructor(
    private _http: HttpClient,
    // private DatatransferService : DatatransferService
    ) 
    {
  }

  
  cards_value(id, apiToken: string) {
    
    return this._http.get("https://api.cognition.world/v1/sustainability/gas/external/dash/" + id, {headers:{'Authorization': apiToken}})
      .map(result => result);
  }
 
   chartConLoad(id, apiToken: string) {
    return this._http.get("https://api.cognition.world/v1/sustainability/gas/external/details/hist/" + id, {headers:{'Authorization': apiToken}})
    
      .map(result => result);
  }

  chartCosConLoad(id, costCon, tempDate3, apiToken: string) {
    return this._http.get("https://api.cognition.world/v1/sustainability/gas/external/details/hist/" + id + "-" + costCon + "-" + tempDate3, {headers:{'Authorization': apiToken}})
   
      .map(result => result);
  }

  chartCosConLoad2(id, costCon, startDay, endDay, apiToken: string) {
    return this._http.get("https://api.cognition.world/v1/sustainability/gas/external/details/hist/" + id + "-" + costCon + "-" + startDay + "-" + endDay, {headers:{'Authorization': apiToken}})
    
      .map(result => result);
  }
 


}


// WEBPACK FOOTER //
// ./src/app/dashboard/gasdetails/gasdetails.service.ts